var modal = document.getElementById('climatepage_modal-img-large');
var img = document.getElementById('climatepage_modal-img-small');
var modalImg = document.getElementById('modal-image');

if (img != null) {
  img.onclick = function() {
    modal.style.display = 'block';
    modalImg.src = this.src;
  };

  var span = document.getElementsByClassName('close')[0];

  span.onclick = function() {
    modal.style.display = 'none';
  };
}
